import "./Solutions.module.css";
import Header from "@/reusable_sections/Header";
import EnvironmentExpertise from "./sections/EnvironmentExpertise";
import CustomSpacePlanning from "./sections/CustomSpacePlanning";
import FooterArchive from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <Header />
      <EnvironmentExpertise />
      <CustomSpacePlanning />
      <FooterArchive />
    </div>;
}